import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { works } from '@/mocks/works';

const slideIds = ['w03', 'w11', 'w07', 'w01'];
const slides = slideIds.map((id) => works.find((w) => w.id === id)!);

export default function HeroCarousel() {
  const [active, setActive] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => setActive((a) => (a + 1) % slides.length), 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {slides.map((slide, idx) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${idx === active ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        >
          <img
            src={slide.cover}
            alt={slide.title}
            title={slide.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/25 to-black/20"></div>
          <div className="absolute inset-0 flex items-end">
            <div className="w-full px-4 md:px-8 pb-10 md:pb-16">
              <div className="max-w-xl">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-label mb-3">
                  本周精选
                </span>
                <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-2">{slide.title}</h2>
                <p className="text-sm md:text-base text-white/80 mb-5 line-clamp-2">{slide.description}</p>
                <button
                  type="button"
                  onClick={() => navigate(`/detail/${slide.id}`)}
                  className="px-5 py-2.5 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-label whitespace-nowrap cursor-pointer transition-colors"
                >
                  查看作品详情
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="absolute bottom-5 right-4 md:right-8 flex gap-2">
        {slides.map((slide, idx) => (
          <button
            key={slide.id}
            type="button"
            aria-label={`切换到第${idx + 1}张`}
            onClick={() => setActive(idx)}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${idx === active ? 'w-6 bg-primary-500' : 'w-1.5 bg-white/50'}`}
          />
        ))}
      </div>
    </section>
  );
}